const { REACT_APP_PATH_API_URL } = process.env;

export const API_V1_PATH = 'api/v1';
export const SPECIPHIC_ASK_API_URL = REACT_APP_PATH_API_URL;
